/**
 * SA-468: a commercial status's tone as a dot and as a soft badge. Pure —
 * the register's Status cell and the STATUS filter dot both read it, so a
 * filter chip always wears the tone of the cell it filters (R1). Queue
 * states and order statuses carry their own `dot` on their config tables;
 * a step's tone is `executorTone`.
 */
import type { VariantProps } from 'class-variance-authority'
import type { badgeVariants } from '@/components/ui/basis/badge'
import type { RecordStatus, StatusTone } from '@/types/commerce'

export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

export const TONE_DOT: Record<StatusTone, string> = {
  info: 'bg-info',
  warning: 'bg-warning',
  success: 'bg-success',
  muted: 'bg-muted-foreground',
  destructive: 'bg-destructive',
}

export const TONE_BADGE: Record<StatusTone, BadgeVariant> = {
  info: 'info-soft',
  warning: 'warning-soft',
  success: 'success-soft',
  muted: 'muted-soft',
  destructive: 'destructive-soft',
}

/** The server always sends `tone`; without one (an older response) this is
 *  the rule the cell painted before SA-468. */
export function statusTone(status: Pick<RecordStatus, 'tone' | 'source'>): StatusTone {
  return status.tone ?? (status.source === 'override' ? 'warning' : 'info')
}
